import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {BrowserRouter} from 'react-router-dom';
import App from './App/index';
import * as serviceWorker from './serviceWorker';
import configStore from './store/index';
import config from './config';
import { NotificationContainer } from './App/components/Notifications/NotificationManager';
import ConfirmacaoRemocaoModal from './App/components/Modals/ConfirmacaoRemocaoModal';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'datatables.net-dt/css/jquery.dataTables.css';
import './App/styles/modal-responsividade.css';
// import 'font-awesome/css/font-awesome.min.css';

const store = configStore();

const app = (
    <Provider store={store}>
        <BrowserRouter basename={config.basename}>
            <App />
        </BrowserRouter>
        <NotificationContainer />
        <ConfirmacaoRemocaoModal />
        <ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
        />
    </Provider>
);

ReactDOM.render(app, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
